import { getErrorMessage } from "../shared/utils";
import axios from "axios";

import * as apiEndPoints from "../shared/apiPaths";
import * as actionTypes from "./actionTypes";

export const getFormFields = (actionId, matterId, screenId, token) => {
  return dispatch => {
    dispatch(getFormFieldsRequest());

    if (
      actionId === undefined ||
      matterId === undefined ||
      screenId === undefined
    ) {
      const emptyResults = [];
      dispatch(getFormFieldsSuccess(emptyResults));
      return;
    }

    const url = window.ENV.API_ROOT + apiEndPoints.SCREEN_FIELDS;

    const data = {
      actionId: actionId,
      matterId: matterId,
      screenId: screenId
    };

    const config = {
      headers: { Authorization: token.token  }  
    };

    axios
      .post(url, data, config)
      .then(response => {
        dispatch(getFormFieldsSuccess(response.data));
      })
      .catch(error => {
        dispatch(getFormFieldsFailure(getErrorMessage(error)));
      });
  };
};

export const fieldsValueChanged = (elementId, value) => {
  return {
    type: actionTypes.FORM_FIELD_VALUE_CHANGED,
    elementId: elementId,
    value: value
  };
};

const getFormFieldsRequest = () => {
  return {
    type: actionTypes.FORM_FIELDS_REQUEST
  };
};

const getFormFieldsFailure = error => {
  return {
    type: actionTypes.FORM_FIELDS_FAILURE,
    error: error
  };
};

const getFormFieldsSuccess = response => {
  return {
    type: actionTypes.FORM_FIELDS_SUCCESS,
    response: response
  };
};

export const resetIsFieldChanged = () => {
  return {
    type: actionTypes.FORM_FIELD_VALUE_RESET
  }
}